import { UncontrolledParameter } from '../uncontrolled-parameter';

export class TbaUncontrolledTransactionsPayload {
  transactionId: number;
  tbaUncontrolledParameters: UncontrolledParameter[];
}
